import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}
export function Modal({
  isOpen,
  onClose,
  children,
  title,
  maxWidth = 'lg'
}: ModalProps) {
  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl'
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center" data-id="element-1812">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-1813" />

      {/* Modal */}
      <div className={`relative w-full ${maxWidthClasses[maxWidth]} mx-4 bg-background-elevated border border-border-subtle rounded-xl shadow-2xl overflow-hidden`} data-id="element-1814">
        {/* Header */}
        {title && <div className="flex items-center justify-between px-6 py-4 border-b border-border-subtle" data-id="element-1815">
            <h2 className="text-lg font-semibold text-text-primary" data-id="element-1816">{title}</h2>
            <button onClick={onClose} className="p-1 hover:bg-background-secondary rounded transition-colors text-text-secondary hover:text-text-primary" data-id="element-1817">
              <X size={20} data-id="element-1818" />
            </button>
          </div>}

        {/* Close button (if no title) */}
        {!title && <button onClick={onClose} className="absolute top-4 right-4 p-1 hover:bg-background-secondary rounded transition-colors text-text-secondary hover:text-text-primary z-10" data-id="element-1819">
            <X size={20} data-id="element-1820" />
          </button>}

        {/* Content */}
        <div className="overflow-y-auto max-h-[80vh]" data-id="element-1821">{children}</div>
      </div>
    </div>;
}